import { render, staticRenderFns } from "./ExpertsIcon.vue?vue&type=template&id=311637c8"
import script from "./ExpertsIcon.vue?vue&type=script&lang=js"
export * from "./ExpertsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports